import {
  FETCH_JUNTA_SUCCESS,
  FETCH_JUNTA_FAILURE,
  FETCH_JUNTA_DETALLES_SUCCESS,
  FETCH_JUNTA_DETALLES_FAILURE,
} from "../actions/junta/types";

const initialState = {
  data: null,
  error: null,
  detalles: null,
};

const juntaReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JUNTA_SUCCESS:
      return { ...state, data: action.payload, error: null };
    case FETCH_JUNTA_FAILURE:
      return { ...state, error: action.payload };
    case FETCH_JUNTA_DETALLES_SUCCESS:
      return { ...state, detalles: action.payload, error: null };
    case FETCH_JUNTA_DETALLES_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default juntaReducer;
